import { render, staticRenderFns } from "./localization.vue?vue&type=template&id=956fa8a2&scoped=true&"
var script = {}
import style0 from "./localization.vue?vue&type=style&index=0&id=956fa8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956fa8a2",
  null
  
)

export default component.exports